
import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from
'@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { ServiceWalkInModel } from '../model/index';

@Injectable()
export class SalesReturnService {
    private headers = new Headers({
        'Content-Type':
        'application/x-www-form-urlencoded', 'Accept':
        'q=0.8;application/json;q=0.9'
    });
    private salesReturnUrl = 'api/salesReturn';
    
    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getSalesReturnList(query: any): Promise<ServiceWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesReturnUrl}/getSalesReturnList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addSaveSalesReturn(pageData: any): Promise<any> {
        const url = `${this.salesReturnUrl}/addSaveSalesReturn`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }

    saveApproval(pageData: any): Promise<any> {
        const url = `${this.salesReturnUrl}/saveApproval`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }


    updateStock(data: any): Promise<any> {
        const url = `${this.salesReturnUrl}/updateStock`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
 
    getSalesReturnDetails(data: any): Promise<ServiceWalkInModel> {

        const url = `${this.salesReturnUrl}/getSalesReturnDetails`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }

    deleteSalesReturn(walkInData: any): Promise<ServiceWalkInModel> {
        const url = `${this.salesReturnUrl}/deleteSalesReturn`;
        return this.http
            .post(url, $.param(walkInData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }

    getMachineReturnApprovalList(query: any): Promise<ServiceWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesReturnUrl}/getMachineReturnApprovalList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
 
    private handleError(error: any): Promise<ServiceWalkInModel> {
        //console.error('An error occurred', error); // for demo
        //purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/salesReturn.service.ts